// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linea-tiempo {
  padding: 20px 0;
  position: relative;
}

.evento {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
  position: relative;
  animation: fadeInLeft 0.4s ease;
  animation-fill-mode: both;
}

.evento:nth-child(1) { animation-delay: 0.05s; }
.evento:nth-child(2) { animation-delay: 0.1s; }
.evento:nth-child(3) { animation-delay: 0.15s; }
.evento:nth-child(4) { animation-delay: 0.2s; }
.evento:nth-child(5) { animation-delay: 0.25s; }
.evento:nth-child(6) { animation-delay: 0.3s; }

.evento:last-child {
  margin-bottom: 0;
}

.evento-linea {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 24px;
}

.evento-punto {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--white);
  border: 3px solid var(--primary);
  box-shadow: 0 0 0 4px var(--primary-light);
  z-index: 1;
  transition: var(--transition);
}

.evento:hover .evento-punto {
  transform: scale(1.2);
  box-shadow: 0 0 0 6px var(--primary-light);
}

.evento-connector {
  width: 2px;
  flex: 1 1;
  background: linear-gradient(180deg, var(--primary-light), var(--gray-200));
  margin-top: 4px;
  border-radius: 1px;
}

.evento:last-child .evento-connector {
  display: none;
}

.evento-content {
  flex: 1 1;
  background: var(--bg-card);
  padding: 20px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  border-left: 4px solid var(--primary);
  box-shadow: var(--shadow-xs);
  transition: var(--transition);
}

.evento:hover .evento-content {
  box-shadow: var(--shadow-md);
  transform: translateX(4px);
  border-left-color: var(--primary-dark);
}

.evento-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.evento-fecha {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.evento-nivel {
  font-size: 11px;
  background: var(--primary);
  color: #ffffff;
  padding: 3px 10px;
  border-radius: var(--radius-full);
  font-weight: 600;
  letter-spacing: 0.3px;
}

.evento-estados {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.estado-anterior {
  font-size: 13px;
  color: var(--gray-400);
  text-decoration: line-through;
  font-weight: 500;
}

.evento-flecha {
  color: var(--primary);
  font-weight: bold;
  font-size: 16px;
  animation: pulse 1.5s ease infinite;
}

.estado-nuevo {
  font-size: 14px;
  font-weight: 700;
  color: var(--primary);
  background: var(--primary-ultralight);
  padding: 4px 12px;
  border-radius: var(--radius-full);
}

.evento-usuario {
  font-size: 13px;
  color: var(--text-muted);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.evento-comentario {
  font-size: 14px;
  color: var(--gray-700);
  background: var(--gray-50);
  padding: 12px 16px;
  border-radius: var(--radius);
  border-left: 3px solid var(--primary);
  line-height: 1.6;
  transition: var(--transition);
}

.evento-comentario:hover {
  background: var(--primary-ultralight);
}

.empty-timeline {
  text-align: center;
  color: var(--text-muted);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.empty-timeline::before {
  content: '⏱️';
  font-size: 40px;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .evento {
    gap: 12px;
  }

  .evento-content {
    padding: 16px;
  }

  .evento-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.evento-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 10px;
  border-top: 1px dashed var(--border);
  padding-top: 8px;
}

.evento-meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.evento-diffs {
  margin-top: 10px;
  background: var(--gray-50);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-size: 13px;
}

.diff-title {
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--gray-600);
}

.diff-item {
  margin-bottom: 4px;
  font-family: monospace;
}

.diff-old {
  color: #c53030;
  background-color: #fff5f5;
  padding: 1px 4px;
  border-radius: 3px;
  text-decoration: line-through;
}

.diff-new {
  color: #2f855a;
  background-color: #f0fff4;
  padding: 1px 4px;
  border-radius: 3px;
}

.linea-tiempo-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px dashed var(--border);
}

.pagination-info {
  font-size: 14px;
  color: var(--text-muted);
  font-weight: 500;
}

[data-theme="dark"] .evento-comentario {
  color: #ffffff;
  background: var(--bg-subtle);
}
[data-theme="dark"] .evento-diffs {
  background: var(--bg-subtle);
}
[data-theme="dark"] .diff-title {
  color: #e2e8f0;
}
[data-theme="dark"] .estado-anterior {
  color: #94a3b8;
}
[data-theme="dark"] .diff-old {
  color: #f87171;
  background-color: rgba(239, 68, 68, 0.15);
}
[data-theme="dark"] .diff-new {
  color: #4ade80;
  background-color: rgba(34, 197, 94, 0.15);
}

[data-theme="dark"] .estado-nuevo {
  color: #60a5fa;
  background: rgba(37, 99, 235, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/LineaTiempo.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,uBAAuB,sBAAsB,EAAE;AAC/C,uBAAuB,qBAAqB,EAAE;AAC9C,uBAAuB,sBAAsB,EAAE;AAC/C,uBAAuB,qBAAqB,EAAE;AAC9C,uBAAuB,sBAAsB,EAAE;AAC/C,uBAAuB,qBAAqB,EAAE;;AAE9C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,0CAA0C;EAC1C,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,SAAO;EACP,0EAA0E;EAC1E,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC","sourcesContent":[".linea-tiempo {\n  padding: 20px 0;\n  position: relative;\n}\n\n.evento {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 28px;\n  position: relative;\n  animation: fadeInLeft 0.4s ease;\n  animation-fill-mode: both;\n}\n\n.evento:nth-child(1) { animation-delay: 0.05s; }\n.evento:nth-child(2) { animation-delay: 0.1s; }\n.evento:nth-child(3) { animation-delay: 0.15s; }\n.evento:nth-child(4) { animation-delay: 0.2s; }\n.evento:nth-child(5) { animation-delay: 0.25s; }\n.evento:nth-child(6) { animation-delay: 0.3s; }\n\n.evento:last-child {\n  margin-bottom: 0;\n}\n\n.evento-linea {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  min-width: 24px;\n}\n\n.evento-punto {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--white);\n  border: 3px solid var(--primary);\n  box-shadow: 0 0 0 4px var(--primary-light);\n  z-index: 1;\n  transition: var(--transition);\n}\n\n.evento:hover .evento-punto {\n  transform: scale(1.2);\n  box-shadow: 0 0 0 6px var(--primary-light);\n}\n\n.evento-connector {\n  width: 2px;\n  flex: 1;\n  background: linear-gradient(180deg, var(--primary-light), var(--gray-200));\n  margin-top: 4px;\n  border-radius: 1px;\n}\n\n.evento:last-child .evento-connector {\n  display: none;\n}\n\n.evento-content {\n  flex: 1;\n  background: var(--bg-card);\n  padding: 20px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--primary);\n  box-shadow: var(--shadow-xs);\n  transition: var(--transition);\n}\n\n.evento:hover .evento-content {\n  box-shadow: var(--shadow-md);\n  transform: translateX(4px);\n  border-left-color: var(--primary-dark);\n}\n\n.evento-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.evento-fecha {\n  font-size: 12px;\n  color: var(--text-muted);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.evento-nivel {\n  font-size: 11px;\n  background: var(--primary);\n  color: #ffffff;\n  padding: 3px 10px;\n  border-radius: var(--radius-full);\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.evento-estados {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.estado-anterior {\n  font-size: 13px;\n  color: var(--gray-400);\n  text-decoration: line-through;\n  font-weight: 500;\n}\n\n.evento-flecha {\n  color: var(--primary);\n  font-weight: bold;\n  font-size: 16px;\n  animation: pulse 1.5s ease infinite;\n}\n\n.estado-nuevo {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--primary);\n  background: var(--primary-ultralight);\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n}\n\n.evento-usuario {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.evento-comentario {\n  font-size: 14px;\n  color: var(--gray-700);\n  background: var(--gray-50);\n  padding: 12px 16px;\n  border-radius: var(--radius);\n  border-left: 3px solid var(--primary);\n  line-height: 1.6;\n  transition: var(--transition);\n}\n\n.evento-comentario:hover {\n  background: var(--primary-ultralight);\n}\n\n.empty-timeline {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.empty-timeline::before {\n  content: '⏱️';\n  font-size: 40px;\n  opacity: 0.5;\n}\n\n@media (max-width: 768px) {\n  .evento {\n    gap: 12px;\n  }\n\n  .evento-content {\n    padding: 16px;\n  }\n\n  .evento-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.evento-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-top: 10px;\n  border-top: 1px dashed var(--border);\n  padding-top: 8px;\n}\n\n.evento-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.evento-diffs {\n  margin-top: 10px;\n  background: var(--gray-50);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  font-size: 13px;\n}\n\n.diff-title {\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--gray-600);\n}\n\n.diff-item {\n  margin-bottom: 4px;\n  font-family: monospace;\n}\n\n.diff-old {\n  color: #c53030;\n  background-color: #fff5f5;\n  padding: 1px 4px;\n  border-radius: 3px;\n  text-decoration: line-through;\n}\n\n.diff-new {\n  color: #2f855a;\n  background-color: #f0fff4;\n  padding: 1px 4px;\n  border-radius: 3px;\n}\n\n.linea-tiempo-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px dashed var(--border);\n}\n\n.pagination-info {\n  font-size: 14px;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n[data-theme=\"dark\"] .evento-comentario {\n  color: #ffffff;\n  background: var(--bg-subtle);\n}\n[data-theme=\"dark\"] .evento-diffs {\n  background: var(--bg-subtle);\n}\n[data-theme=\"dark\"] .diff-title {\n  color: #e2e8f0;\n}\n[data-theme=\"dark\"] .estado-anterior {\n  color: #94a3b8;\n}\n[data-theme=\"dark\"] .diff-old {\n  color: #f87171;\n  background-color: rgba(239, 68, 68, 0.15);\n}\n[data-theme=\"dark\"] .diff-new {\n  color: #4ade80;\n  background-color: rgba(34, 197, 94, 0.15);\n}\n\n[data-theme=\"dark\"] .estado-nuevo {\n  color: #60a5fa;\n  background: rgba(37, 99, 235, 0.15);\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
